<template lang="pug">
  transition(name='modal')
    .modal-mask(@click.self="closeModal()")
      .modal-wrapper(@click.self="closeModal()")
        .modal-container(:style="containerStyle")
          .modal-header
            p.title {{ titulo }}
            el-button.btn#btn(
              type="text",
              @click="triggerCloseModal()",
              @mouseover.native="hover",
              @mouseout.native="leave",
              :style="getColor",
              size="mini"
            )
              i.material-icons.icon close

          .modal-body(:style="{ padding:  '0px ' +  padding + 'px' }")
            slot(name="body")
          .modal-footer
            slot(name="footer")

</template>

<script>
export default {
  props: {
    titulo: {
      type: String,
      required: true
    },
    width: {
      type: Number,
      default: 800
    },
    closeOutside: {
      type: Boolean,
      default: true
    },
    padding: {
      type: Number,
      default: 10
    },
    height: {
      type: Number
    }
  },

  data() {
    return {
      colorCopy: "#666666",
      hoverColor: "#366efa"
    };
  },

  computed: {
    getColor() {
      if (this.colorCopy) {
        return `color: ${this.colorCopy}`;
      }
      return "";
    },

    containerStyle() {
      const style = {
        width: `${this.width}px`
      };

      if (this.height) {
        style.height = `${this.height}px`;
      }

      return style;
    }
  },

  methods: {
    closeModal() {
      if (this.closeOutside) {
        this.triggerCloseModal();
      }
    },

    triggerCloseModal() {
      this.$emit("closeModal");
    },

    hover() {
      this.colorCopy = this.hoverColor;
    },

    leave() {
      this.colorCopy = this.cor;
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/style/_variables.scss";

.modal-mask {
  position: fixed;
  z-index: 1001;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  margin-top: 8vh;
}

.modal-container {
  min-height: 200px;
  max-height: 84vh;
  margin: 0px auto;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
  -moz-border-radius: 5px;
  -webkit-border-radius: 5px;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 5px solid $color-primary;
}

.modal-body {
  overflow-y: auto;
  max-height: 76vh;
  flex-grow: 1;
}

.modal-footer {
  padding: 8px 5px;
  height: 60px;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.title {
  margin: 0;
  font-size: 18px;
  color: $color-primary;
  padding: 0 10px;
}

.btn {
  padding-right: 5px;
  color: #666666;

  .icon {
    font-size: 18px;
  }
}
</style>
